<template>
  <tr>
    <td>
      {{ extra.name }}
      <translate v-if="isFree(extra.price)" tag="span" class="free">
        Free
      </translate>
      <span class="max">
        <translate v-if="isCompulsory">(compulsory)</translate>
        <translate v-else-if="!isCompulsory && isUnlimited"
          >(max unlimited)</translate
        >
        <translate
          v-else-if="hasPitchtypeExtraIncluded"
          :tt="{ max: extra.max, included: pitchtypeExtraIncluded }"
          >({max} max - {included} dogs are included in the price)</translate
        >
        <translate v-else :tt="{ max: extra.max }"
          >({max, number} max)</translate
        >
      </span>
      <pu-popover
        v-if="extra.description || (extra.terms && extra.terms.length)"
      >
        <template #content>
          <span
            v-thtml="getPopoverContent(extra.description, extra.terms)"
            data-g-translate="extra"
          />
          <google-translate-button
            v-if="extra.descriptionNeedsTranslation"
            query-selector-value="extra"
          />
        </template>
      </pu-popover>
    </td>
    <td>
      <slot name="select" />
    </td>
    <td>
      <slot name="price" />
    </td>
  </tr>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
/* TODO: Add proper typing to resolve type safety warnings */
import {
  ChargeTypeExtra,
  PitchTypeExtra,
} from '../../apps/campsite-details/types'
import { MoneyRaw, MoneyType, toMoneyType } from '../../utility/money'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class BaseExtra extends Vue {
  @Prop({ required: true })
  extra: ChargeTypeExtra | PitchTypeExtra

  get isCompulsory() {
    return this.extra.compulsory
  }

  get isUnlimited() {
    return this.extra.max === null || this.extra.max === Infinity
  }

  get pitchtypeExtra() {
    return this.extra.pitchtypeExtra
  }

  get pitchtypeExtraIncluded() {
    return this.pitchtypeExtra?.included
  }

  get pitchtypeExtraMax() {
    return this.pitchtypeExtra?.maximum
  }

  get hasPitchtypeExtraIncluded() {
    return !!this.pitchtypeExtraIncluded
  }

  isFree(price: MoneyRaw | MoneyType) {
    if (!price) {
      return
    }
    price = toMoneyType(price)
    return price && price.getAmount() === 0
  }

  getPopoverContent(description: string, terms: string[] | null) {
    let content = ''
    if (description) {
      content += `<p>${description}</p>`
    }
    if (terms) {
      for (const term of terms) {
        content += `<p>${term}</p>`
      }
    }

    return content
  }
}

export default toNative(BaseExtra)
</script>

<style scoped>
tr td:last-of-type {
  text-align: right;
  white-space: nowrap;
  padding-left: 0.5em;
}

td {
  position: relative;
  vertical-align: middle;
}

.free {
  background: white;
  border-radius: 0.45em;
  display: inline-flex;
  font-size: var(--small);
  font-weight: 600;
  padding: 0.05em 0.4em 0.1em;
  color: var(--colour-dark-blue);
  border: 1px solid var(--colour-text-light);
}
</style>
